export default "/fonts/vendor/@fontsource/lato/files/lato-latin-700-normal.woff?1dccf99a7a009cd0c13415c41089a788";